import {useEffect, useState} from 'react'
import './assets/theme/style.scss'

const {
  REACT_APP_CASHIER_URL,
  REACT_APP_AGENT_URL,
  REACT_APP_SUPER_AGENT_URL,
  REACT_APP_OWNER_URL,
  REACT_APP_LABEL_FLAG,
} = process.env

const projects = REACT_APP_LABEL_FLAG === 'whitelabel-4' ? [
  // {
  //   name: 'general',
  //   link: REACT_APP_OWNER_URL,
  // },
  {
    name: 'super admin',
    link: REACT_APP_SUPER_AGENT_URL,
  },
  {
    name: 'admin',
    link: REACT_APP_AGENT_URL,
  },
  {
    name: 'shop',
    link: REACT_APP_CASHIER_URL,
  },
] : (['whitelabel-12', 'whitelabel-3', 'whitelabel-15', 'whitelabel-25'].includes(REACT_APP_LABEL_FLAG) ? [
  {
    name: 'super agent',
    link: REACT_APP_SUPER_AGENT_URL,
  },
  {
    name: 'agent',
    link: REACT_APP_AGENT_URL,
  },
  {
    name: 'cashier',
    link: REACT_APP_CASHIER_URL,
  },

] : [
  {
    name: REACT_APP_LABEL_FLAG === 'whitelabel-19' ? 'shop agent' : 'owner',
    link: REACT_APP_OWNER_URL,
  },
  {
    name: 'super agent',
    link: REACT_APP_SUPER_AGENT_URL,
  },
  {
    name: 'agent',
    link: REACT_APP_AGENT_URL,
  },
  {
    name: 'cashier',
    link: REACT_APP_CASHIER_URL,
  },
])

function App() {
  const mode = localStorage.getItem('mode')
  const [checked, setChecked] = useState(mode === 'dark')
  const toggleBodyClassHandler = (evt) => {
    if (evt.target.checked) {
      document.body.classList.add('dark')
      localStorage.setItem('mode', 'dark')
      setChecked(true)
    } else {
      document.body.classList.remove('dark')
      localStorage.setItem('mode', '')
      setChecked(false)
    }
  }

  useEffect(() => {
    if (localStorage.getItem('mode') === 'dark') {
      localStorage.setItem('mode', 'dark')
      document.body.classList.add('dark')
    }
  }, [])

  return (
    <div className="App">
      <div className="wrapper">
        <section className="wrapperInner">
          <div className="myCards">
            <div className="myCards__list">
              {projects.map((project, index) => (
                  <a className="myCards__link" key={project.name} href={project.link}>
                    <div className="myCards__icon">{index + 1}</div>
                    <span className="myCards__name">{project.name}</span>
                  </a>
              ))}
            </div>
          </div>
        </section>
      </div>
      <footer className="footer"/>
    </div>
  )
}

export default App
